import Model from './Model'

export default class Quote extends Model {

    getFormAttributes() {
        return this;
//        return this.only(['date', 'package_id', 'location', 'key_activities', 'key_hazards', 'given_by_name', 'given_by_position'])
    }

    static parseAttributes(attributes = {}) {
        attributes = this.parseDropdownAttributes(attributes);
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = ['NICE']
        this.secured_at = new Date(this.secured_at);
        this.tokens = tokens.join('|').toLowerCase();
    }
}

